export type Channel = 'web' | 'apps_in_toss';

export const channel: Channel = import.meta.env.MODE === 'toss' ? 'apps_in_toss' : 'web';

export async function openExternal(url: string): Promise<void> {
  const parsed = new URL(url);
  if (!['http:', 'https:'].includes(parsed.protocol)) throw new Error('UNSAFE_EXTERNAL_URL');
  if (import.meta.env.MODE === 'toss') {
    try {
      const { Device } = await import('@apps-in-toss/web-framework');
      await Device.openURL(parsed.toString());
    } catch {
      window.dispatchEvent(new CustomEvent('bodochai:external-failed',{detail:parsed.toString()}));
    }
    return;
  }
  window.open(parsed.toString(), '_blank', 'noopener,noreferrer');
}

export async function shareText(text:string):Promise<'shared'|'copied'|'cancelled'|'fallback'>{
 if(import.meta.env.MODE==='toss'){
  const {share,getTossShareLink}=await import('@apps-in-toss/web-framework');let link='';try{link=await getTossShareLink('intoss://coverage-timeline');}catch{}
  try{await share({message:text+(link?'\n\n'+link:'')});return 'shared';}catch(error){if(error instanceof Error&&error.name==='AbortError')return 'cancelled';throw error;}
 }
 const message=text+'\n\nhttps://bodochai.com';
 if(navigator.share){try{await navigator.share({text:message});return 'shared';}catch(error){if(error instanceof Error&&error.name==='AbortError')return 'cancelled';}}
 try{await navigator.clipboard.writeText(message);return 'copied';}catch{return 'fallback';}
}
